'use client';
import { useEffect } from 'react';
import { useViewStore } from '@/stores';

export default function LearnLayout({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    return () => {
      if (useViewStore.getState().showChapterNote) {
        useViewStore.getState().toggleChapterNote();
      }
    };
  }, []);

  return <>{children}</>;
}
